import {
  Tooltip,
  Avatar,
  Box,
  Flex,
  Icon,
  Spacer,
  Text,
} from "@chakra-ui/react";
import { BiBookReader } from "react-icons/bi";
import { Link } from "react-router-dom";

const AuthorFooter = ({ readingOrder }) => (
  <Box pt="3" px="3" pb="3">
    <Flex w="100%" alignItems="center" px="3">
      <Box w="120px">
        <Tooltip
          hasArrow
          label={`${readingOrder.readingCount} readers added this to their list`}
          placement="bottom"
          bg="black"
          color="white"
        >
          <Text fontSize="sm">
            <Icon as={BiBookReader} /> {readingOrder.readingCount || 0}{" "}
            {readingOrder.readingCount === 1 ? "reader" : "readers"}
          </Text>
        </Tooltip>
      </Box>
      <Spacer />
      <Flex flexGrow="1" alignItems="center" justifyContent="flex-end">
        <Box
          flexWrap="wrap"
          display="flex"
          flexDirection="row"
          alignItems="center"
        >
          <Text fontSize="xs" textAlign="right">
            Created by &nbsp;
          </Text>
          <Link to={`/profile/${readingOrder.author.userHandle}`}>
            <Text fontSize="sm" as="b">
              {readingOrder.author.userHandle}
            </Text>
          </Link>
        </Box>
        <Link to={`/profile/${readingOrder.author.userHandle}`}>
          <Avatar
            size="sm"
            name={readingOrder.author.userHandle}
            src={readingOrder.author.profilePicture}
            ml="3"
          />
        </Link>
      </Flex>
    </Flex>
  </Box>
);

export default AuthorFooter;
